import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "checkoutagreementsnegotiablequote-module-overview"
    }}>{`CheckoutAgreementsNegotiableQuote module Overview`}</h2>
    <p>{`CheckoutAgreementsNegotiableQuote module extends CheckoutAgreements if it is enabled in configuration and it adds agreements to payment data on checkout with negotiable quote.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.5.1.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      